export default Object.freeze({
  Success: 'success',
  Error: 'error',
  Info: 'info',
  Warning: 'warning',
});
